//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { siteStandardOnlineByArea } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    this.querySewageQuotaList('52');
  },
  methods: {
    initBarLineChart: function initBarLineChart(data) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            textStyle: {
              color: '#fff'
            }
          }
        },
        grid: {
          borderWidth: 0,
          top: 50,
          bottom: 30,
          left: 40,
          textStyle: {
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,.5)'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: 'rgba(255,255,255,0.7)',
            fontSize: 14
          },
          data: data.xData
        }],
        yAxis: [{
          type: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: 'rgba(255,255,255,0.5)',
            fontSize: 14
          },
          splitArea: {
            show: false
          }
        }],
        series: [{
          name: '达标',
          type: 'bar',
          stack: '站点数',
          barMaxWidth: 35,
          barGap: '10%',
          itemStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(35, 157, 250, 1)' // 0% 处的颜色

                }, {
                  offset: 1,
                  color: 'rgba(35, 157, 250, 0)' // 100% 处的颜色

                }],
                global: false // 缺省为 false

              }
            }
          },
          data: data.qualifiedData
        }, {
          name: '不达标',
          type: 'bar',
          stack: '站点数',
          itemStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(35, 250, 187, 1)' // 0% 处的颜色

                }, {
                  offset: 1,
                  color: 'rgba(35, 250, 187, 0)' // 100% 处的颜色

                }],
                global: false // 缺省为 false

              },
              barBorderRadius: 0
            }
          },
          data: data.unqualifiedData
        }, {
          name: '总数',
          type: 'line',
          symbolSize: 10,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: 'rgba(255, 196, 53, 1)',
              barBorderRadius: 0
            }
          },
          lineStyle: {
            normal: {
              width: 4,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(255, 67, 2, 1)' // 0% 处的颜色

                }, {
                  offset: 1,
                  color: 'rgba(255, 196, 53, 1)' // 100% 处的颜色

                }],
                global: false // 缺省为 false

              }
            }
          },
          data: data.totalData
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(st) {
      var _this = this;

      var data = {
        xData: [],
        qualifiedData: [],
        unqualifiedData: [],
        totalData: []
      };
      siteStandardOnlineByArea({
        st: st
      }).then(function (res) {
        if (res.success) {
          for (var key in res.result) {
            data.xData.push(key);
            data.qualifiedData.push(res.result[key].compliant);
            data.unqualifiedData.push(res.result[key].totle - res.result[key].compliant);
            data.totalData.push(res.result[key].totle);
          }

          _this.initBarLineChart(data);
        }
      });
    }
  }
};